module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-700.90e1ac1.woff";